import screens from './screens'
import errors from './validate'

export default {
  screens,
  errors
}
